import CardDetails from './CardDetails';

export default CardDetails;
